export default __webpack_public_path__ + "static/media/group_3.60bf05c8.webp";